import React from 'react';
import { useParams } from 'react-router-dom';
import StreamOverlayFull from './StreamOverlayFull';
import StreamOverlayNoCamera from './StreamOverlayNoCamera';
import StreamOverlayFullSummer from './StreamOverlayFullSummer';
import StreamOverlayNoCameraSummer from './StreamOverlayNoCameraSummer';
import useOverlayTheme from '../hooks/useOverlayTheme';
import { overlayRootStyles } from '../overlayThemes/overlayRootStyles';

export default function StreamOverlayThemed({ camera = false }) {
  const { channelName } = useParams();
  const normalizedChannel = channelName?.toLowerCase().trim() || 'itsflannelbeard';
  const { theme } = useOverlayTheme(normalizedChannel);

  const overlay = theme === 'summer'
    ? (camera ? <StreamOverlayFullSummer /> : <StreamOverlayNoCameraSummer />)
    : (camera ? <StreamOverlayFull /> : <StreamOverlayNoCamera />);

  return (
    <>
      <style>{overlayRootStyles}</style>
      {overlay}
    </>
  );
}
